"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendToBack = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var SendToBack = function () { return (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M2 2H14.8V14.8H2L2 2ZM0 2C0 0.895431 0.895431 0 2 0H14.8C15.9046 0 16.8 0.895431 16.8 2V7.2H22C23.1046 7.2 24 8.09543 24 9.2V22C24 23.1046 23.1046 24 22 24H9.2C8.09543 24 7.2 23.1046 7.2 22V16.8H2C0.895431 16.8 0 15.9046 0 14.8V2Z", clipRule: "evenodd" }))); };
exports.SendToBack = SendToBack;
//# sourceMappingURL=send-to-back.js.map